import bwTypeMap from "./TypeData.json";
export default bwTypeMap;
